import { useCallback, useState } from 'react'

export const useModal = (initialState = false) => {
  // Initialize the state
  const [isVisible, setIsVisible] = useState(initialState)

  const openModal = useCallback(() => setIsVisible(true), [])

  const closeModal = useCallback(() => setIsVisible(false), [])

  return { isVisible, setIsVisible, openModal, closeModal }
}
